import { render, staticRenderFns } from "./PassSafeguardTermination.vue?vue&type=template&id=07d08df8&"
import script from "./PassSafeguardTermination.vue?vue&type=script&lang=js&"
export * from "./PassSafeguardTermination.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeguardTermination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports